module.exports = __webpack_public_path__ + "img/icon-coin-reward.e8b63497.svg";